<template>
  <router-link to="/">
    <img src="@/assets/tracktalent_logo.svg" alt="Logo" class="h-10 mx-auto" />
  </router-link>
</template>
